import React from 'react';
import {Col} from 'react-bootstrap';

const DateTimeWidok = ({ value, type, isDanger }) => {
  return (
    <Col xs={3} className={isDanger ? 'countdown danger' : 'countdown'}>
      <span><b className="zegar">{type}</b> : <i className="czas">{value}</i></span>
    </Col>
  );
};

export default DateTimeWidok;